import React from 'react';
import { Button } from 'antd';
import CodeMirror from '@uiw/react-codemirror';
import { StreamLanguage } from '@codemirror/language';
import { yaml } from '@codemirror/legacy-modes/mode/yaml';

const codeMirrorBasicSetup = {
  highlightSelectionMatches: false,
};

const MappingUpdatePane = ({ onChange, onSave, onCancel, code }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'stretch',
      justifyContent: 'flex-start',
    }}
  >
    <div className="advanced-mapping">
      <CodeMirror
        value={code || ''}
        onChange={onChange}
        extensions={[StreamLanguage.define(yaml)]}
        basicSetup={codeMirrorBasicSetup}
      />
    </div>
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        marginTop: 10,
      }}
    >
      <div>
        <Button type="primary" onClick={() => onSave(code)}>
          Save
        </Button>
      </div>
      <div style={{ marginLeft: 10 }}>
        <Button onClick={() => onCancel()}>Cancel</Button>
      </div>
    </div>
  </div>
);

export default MappingUpdatePane;
